<template>
  <div class="login-container">
    <div class="login-box">
      <h2>{{$t('login.welcome')}}</h2>
      <el-form :model="loginForm" :rules="rules" ref="loginForm">
        <el-form-item prop="userAccount">
          <el-input
            v-model="loginForm.userAccount"
            :placeholder="$t('login.accountPlaceholder')"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            type="password"
            :placeholder="$t('login.passwordPlaceholder')"
            show-password
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="login-btn" @click="handleLogin"
            >{{ $t('login.loginBtn') }}</el-button
          >
        </el-form-item>
      </el-form>
      <div class="register-link">
        {{$t('login.noAccount')}}
        <el-link type="primary" @click="confirmEmail" style="margin-left: 6px;font-family: 'AzonixRegular', sans-serif;"
          >{{ $t('login.register') }}</el-link
        >
      </div>
    </div>

    <div class="footer">{{ $t('login.footer') }}</div>

    <!-- 邮箱验证弹窗 -->
    <el-dialog
      title="Confirm Email"
      :visible="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >

    </el-dialog>
  </div>
</template>

<script>
import { login } from '@/api/user'
import { encrypt } from '@/utils/crypto'

/**
 * @description 登录页面组件
 */
export default {
  name: 'Login',
  data () {
    return {
      loginForm: {
        userAccount: '',
        password: ''
      },
      rules: {
        userAccount: [
          {
            required: true,
            message: this.$t('login.enterUserAccount'),
            trigger: 'blur'
          },
          {
            min: 3,
            max: 20,
            message: this.$t('login.length3to20'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('validation.enterPassword'),
            trigger: 'blur'
          },
          {
            min: 6,
            message: this.$t('validation.passwordMin6'),
            trigger: 'blur'
          }
        ]
      },
      dialogVisible: false
    }
  },
  methods: {
    /**
     * @description 处理登录请求
     */
    handleLogin () {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const params = {
            userAccount: this.loginForm.userAccount,
            password: encrypt(this.loginForm.password)
          }
          login(params).then((res) => {
            if (res.code === 200) {
              console.log('%c FXY', 'color: #46cef9;font-size:37px', res)
              this.$store.dispatch('user/loginSuccess', {
                user: res.data
              })
              this.$message.success(this.$t('login.loginSuccess'))
              const { topic } = this.$route.query
              if (res.data.role === 'P') {
                this.$router.push({
                  path: '/SelectUser',
                  query: { topic }
                })
                return false
              }
              // 获取重定向信息
              const { redirect } = this.$route.query
              if (redirect === '/chat' && topic) {
                this.$router.push({
                  path: redirect,
                  query: { topic }
                })
              } else {
                this.$router.push('/')
              }
            } else {
              this.$message.error(res.message || this.$t('login.loginFailed'))
            }
          })
        }
      })
    },
    /**
     * @description 打开邮箱验证弹窗
     */
    confirmEmail () {
      this.$router.push({
        path: '/register'
      })
    },
    handleCommand (command) {
      this.$i18n.locale = command === 'French' ? 'fr' : 'en'
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  padding: 15px;
  padding-top: 130px;
}

.login-box {
  width: 100%;
  max-width: 400px;
  padding: 30px 20px;
  background: #fff;
  border-radius: 8px;
}

.login-box h2 {
  text-align: center;
  margin-bottom: 25px;
  color: #409eff;
  font-size: 24px;
  font-family: 'AzonixRegular', sans-serif;
}

.login-btn {
  width: 100%;
  height: 40px;
}
:deep(.el-button span) {
  font-family: 'AzonixRegular', sans-serif !important;
}
.register-link {
  margin-top: 15px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: 'AzonixRegular', sans-serif;
}

.footer {
  text-align: center;
  color: #666;
  font-size: 13px;
  font-family: 'AzonixRegular', sans-serif;
}

:deep(.el-form-item) {
  margin-bottom: 15px;
}
:deep(.el-link--inner) {
  font-family: 'AzonixRegular', sans-serif !important;
}

:deep(.el-input__inner) {
  height: 40px;
  font-size: 14px;
}

/* 移动端适配 */
@media screen and (min-width: 768px) {
  .login-container {
    padding: 20px;
  }

  .login-box {
    padding: 40px;
  }

  .login-box h2 {
    margin-bottom: 30px;
    font-size: 28px;
  }

  .login-btn {
    height: 45px;
  }

  .register-link {
    margin-top: 20px;
    font-size: 15px;
  }

  .footer {
    font-size: 14px;
  }

  :deep(.el-form-item) {
    margin-bottom: 20px;
  }

  :deep(.el-input__inner) {
    height: 45px;
    font-size: 15px;
  }
}
</style>
